import { useTheme as muiUseTheme } from '@mui/material/styles';
import baseMakeStyles, { CustomMakeStyles } from '@shared/theme/makeStyles';
import { CVTheme } from './buildTheme';

export const makeStyles = baseMakeStyles as CustomMakeStyles<CVTheme>;

export const useTheme = muiUseTheme as () => CVTheme;

export { default as buildTheme } from './buildTheme';
